import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: localStorage.getItem('userDetails') || {},
  error: "",
  loading: false,
  isUserLogout: false,
  errorMsg: false,
  user_image: localStorage.getItem('user_image') || null,
  user_name: localStorage.getItem('user_name')||null,
  email:localStorage.getItem('email') || null,
  phone:localStorage.getItem('phone') || null,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
    

      state.error = action.payload;
      state.loading = false;
      state.isUserLogout = false;
      state.errorMsg = true;
      localStorage.removeItem('authToken')
    },
    loginSuccess(state, action) {
      state.user = action.payload.Details
      localStorage.setItem('user_image', action.payload.Details.user_image)
      state.user_image = action.payload.Details.user_image
      localStorage.setItem('user_name', action.payload.Details.User_Name)
      state.user_name = action.payload.Details.User_Name
      localStorage.setItem('email', action.payload.Details.Email)
      state.email = action.payload.Details.Email
      localStorage.setItem('phone', action.payload.Details.Phone)
      state.phone = action.payload.Details.Phone
      state.loading = false;
      state.errorMsg = false;
    },
    logoutUserSuccess(state, action) {
   
      state.isUserLogout = true
      state.user={}
      localStorage.removeItem('authUser')
    },
    reset_login_flag(state) {
      state.error = null
      state.loading = false;
      state.errorMsg = false;
    },
    enable_login_loader(state){
          state.loading=true
    },
    set_user_image_success(state,action){
      state.user_image = action.payload
      state.loading= false;
    },
    set_user_image_fail(state,action){
      state.loading= false;
    },
    update_user_details_success(state,action){
      const {email, phone } = action.payload

      localStorage.setItem('email', email)
      state.email = email
      localStorage.setItem('phone', phone)
      state.phone = phone

      state.loading = false;
      state.errorMsg = false;
    },
    update_user_details_fail(state,action){
      state.loading= false
    }
  },
});

export const {
  apiError,
  loginSuccess,
  logoutUserSuccess,
  reset_login_flag,
  enable_login_loader,
  set_user_image_success,
  set_user_image_fail,
  update_user_details_success
} = loginSlice.actions

export default loginSlice.reducer;